import { Injectable } from '@angular/core';
import { Play } from '@r1-compass-library/models';
import { Dependency } from '@r1-compass-library/models/dependencies.model';
import { PlayService } from '@r1-compass-library/services/play.service';
import { PlayFolderService } from '@r1-compass-library/services/play-folder.service';
import { AssetListState, AssetListStore } from '@r1-compass-library/store/asset-list.store';

@Injectable()
export class PlaysListStore extends AssetListStore<Play, PlayService, PlayFolderService> {
    protected override initialState: AssetListState<Play> = {
        assets: [],
        folders: [],
        currentFolder: null,
        message: undefined,
    };

    assetTypeName = 'Play Folder';

    constructor(assetRestService: PlayService, folderRestService: PlayFolderService) {
        super(assetRestService, folderRestService);
    }

    protected handleDependencies(assets: Play[]): void {
        //no-op since play doesn't have any dependencies itself
    }

    protected override buildDependencies(play: Play, assets: Play[]): Dependency[] {
        //functionally no-op since play doesn't have any dependencies itself
        return [];
    }
}
